import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = { class: "text-bold" }

import store from '@/store'
import { ref, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCategorySuccessfully',
  props: {
  messageSave: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'Success',
  },
},
  setup(__props) {

const props = __props;



const typeColors = {
  error: '#E11B11',
  warning: '#FF8A0C',
  success: '#00842F',
  neutral: '#667387',
}

const alertColor = ref('#667387')

const closeAlert = () => {
  store.dispatch('setAlertShown', {
    show: false,
    message: '',
  })
}

onMounted(() => {
  for (const type in typeColors) {
    if (type == props.type) alertColor.value = typeColors[type]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: closeAlert,
    class: "add-category-successfully"
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15.293 24.2929C15.6836 23.9024 16.3167 23.9024 16.7073 24.2929L21.1908 28.7764L30.865 19.1023C31.2555 18.7117 31.8886 18.7117 32.2792 19.1023C32.6697 19.4928 32.6697 20.1259 32.2792 20.5165L21.8979 30.8977C21.5074 31.2883 20.8742 31.2883 20.4837 30.8977L15.293 25.7071C14.9025 25.3166 14.9025 24.6834 15.293 24.2929Z",
        fill: alertColor.value
      }, null, 8, _hoisted_2),
      _createElementVNode("rect", {
        x: "1",
        y: "1",
        width: "46",
        height: "46",
        rx: "23",
        stroke: alertColor.value,
        "stroke-width": "2"
      }, null, 8, _hoisted_3)
    ])),
    _createElementVNode("h4", _hoisted_4, _toDisplayString(__props.messageSave), 1)
  ]))
}
}

})